import React from 'react'
import Box from '@mui/material/Box';
import { useState,useEffect } from 'react'
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useAuth0 } from "@auth0/auth0-react";
import Button from '@mui/material/Button';
import moment from "moment";

export default function DataGridDemo() {

  const columns: GridColDef[] = [
    { field: 'url', headerName: 'Url', width: 250 },
    { field: 'timestamp', headerName: 'Timestamp', width: 160,   type: 'dateTime',  valueFormatter: params => moment(params?.value).format("DD.MM.YYYY HH:mm:ss") },
    { field: 'ccid', headerName: 'CCID', width: 150 },
    { field: 'period', headerName: 'Period', width: 80 },
    { field: 'visits', headerName: 'Visits', width: 80 },
    { field: 'decisions.allow', headerName: 'Allow', width: 80, valueGetter: (params) => params.row.decisions?.allow || 0  },
    { field: 'decisions.reject', headerName: 'Reject', width: 80, valueGetter: (params) => params.row.decisions?.reject || 0  },
    { field: 'decisions.mixed', headerName: 'Mixed', width: 80, valueGetter: (params) => params.row.decisions?.mixed || 0 },  
    

  ];

    const { getAccessTokenSilently } = useAuth0();
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = React.useState(false)

    const loadData = async() => {

      setLoading(true)

      const token = await getAccessTokenSilently();

      const response = await fetch(process.env.REACT_APP_REPORTS_URL +"?reportId=rep005", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      if (response.status) {
          const data = await response.json();
          if (data != null)
            setTableData(data.rep005);
          console.log("data loaded.")
        }
      setLoading(false)
    };

    useEffect(() => {

      loadData();
      // eslint-disable-next-line
    }, [])

    
    //search button
    const buttonHandler = async() => {

      loadData();

    };



  return (
    <Box sx={{ height: `auto`, width: '100%' }}>

        <Box
            component="form"
            sx={{
            '& .MuiTextField-root': { m: 1, width: '1000' },
            }}
            noValidate
            autoComplete="off"
          >
                <div  style={{
                    display: 'flex',
                    alignItems: 'center'
                }}>
                
                
                <Button variant="contained" onClick={buttonHandler}>Refresh</Button>&nbsp;&nbsp;

            </div> 
      </Box>

      <DataGrid
        rows={tableData}
        columns={columns}
        pageSize={13}
        rowsPerPageOptions={[13]}
        disableSelectionOnClick
        autoHeight={true}
        experimentalFeatures={{ newEditingApi: true }}
        rowCount={tableData.length}
        loading={loading}
      />

    </Box>
  );
}